import styled from 'styled-components';

import Button from '~/components/Button';
import SideSheetNative from '~/components/SideSheet';
import TextNative from '~/components/Text';

export const SideSheet = styled(SideSheetNative)`
  width: 42%;
  padding-bottom: 50px;
`;

export const Text = styled(TextNative)`
  margin-bottom: 4px;
  word-break: break-all;
  line-height: 16px;
  display: flex;
  align-items: center;
  white-space: break-spaces;
`;

export const WrapperLoading = styled(TextNative)`
  margin-top: 24px;
`;

export const ButtonCopy = styled(Button)`
  margin-left: 4px;
`;

export const Space = styled.div`
  height: 25px;
`;

export const Content = styled.div`
  width: 100%;
  padding: 22px;
  height: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
`;
